import React from 'react';
import PropTypes from 'prop-types';
import {
  FloatingLabelInput as Input,
  SelectableBlock
} from '../../../Elements';
import { Checkbox, Icon, Popup } from 'semantic-ui-react';
import styles from './SignatureBlocks.scss';

export default class SignatureBlockFields extends React.Component {
  static propTypes = {
    isTemplate: PropTypes.bool,
    localSignatureBlock: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    submitted: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.fieldChange = this.fieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.isVisible = this.isVisible.bind(this);
    this.setVisibility = this.setVisibility.bind(this);
    this.checkboxChange = this.checkboxChange.bind(this);
    this.selectField = this.selectField.bind(this);
  }

  setVisibility(field, visibility) {
    this.fieldChange(
      `${field}_visibility`,
      visibility === true ? 'SHOW' : 'HIDE'
    );
    this.fieldChange(field, null);
  }

  isVisible(visibility) {
    return visibility === 'SHOW';
  }

  checkboxChange(e, data) {
    this.fieldChange(data.name, data.checked);
  }

  selectField(e, data) {
    this.setVisibility(data.name, data.checked);
  }

  fieldChange(key, value) {
    const newValue = {};
    newValue[key] = value;
    this.props.onChange(
      Object.assign(this.props.localSignatureBlock, newValue)
    );
  }

  textFieldChange(e) {
    this.fieldChange(e.target.name, e.target.value);
  }

  render() {
    const { localSignatureBlock } = this.props;
    const signingPartyHelp = (
      <Icon name='help circle' className={styles.helpIcon} />
    );
    return (
      <div>
        <div className={styles.optional}>
          <Input
            label='Signing Party'
            name='signing_party'
            placeholder='(Eg. Client)'
            required
            validationError='Signing party is required'
            value={localSignatureBlock.signing_party || ''}
            onChange={this.textFieldChange}
            submitted={this.props.submitted}
            width='100%'
          />
          <Popup
            trigger={signingPartyHelp}
            on='hover'
            position='right center'
            inverted
            content='This value should correspond to the party defined in your contract terms (E.g. Client or Purchaser)'
          />
        </div>
        {this.props.isTemplate &&
          <div>
            <br />
            <p>
              <strong>
                Please select the information you would like the signing party
                to provide:
              </strong>
            </p>
            <SelectableBlock
              cardBorder
              checkbox
              checked={this.isVisible(localSignatureBlock.name_visibility)}
              content='Name'
              onChange={this.selectField}
              name='name'
            />
            <br />
            <SelectableBlock
              cardBorder
              checkbox
              checked={this.isVisible(localSignatureBlock.email_visibility)}
              content='Email'
              onChange={this.selectField}
              name='email'
            />
            <br />
            <SelectableBlock
              cardBorder
              checkbox
              checked={this.isVisible(localSignatureBlock.phone_visibility)}
              content='Phone Number'
              onChange={this.selectField}
              name='phone'
            />
            <br />
            <SelectableBlock
              cardBorder
              checkbox
              checked={this.isVisible(
                localSignatureBlock.company_name_visibility
              )}
              content='Company Name'
              onChange={this.selectField}
              name='company_name'
            />
            <br />
            <SelectableBlock
              cardBorder
              checkbox
              checked={this.isVisible(localSignatureBlock.title_visibility)}
              content='Title'
              onChange={this.selectField}
              name='title'
            />
            <br />
            <SelectableBlock
              cardBorder
              checkbox
              checked={this.isVisible(localSignatureBlock.address_visibility)}
              content='Address'
              onChange={this.selectField}
              name='address'
            />
          </div>}
        {!this.props.isTemplate &&
          <div>
            {this.isVisible(localSignatureBlock.name_visibility) &&
              <div className={styles.optional}>
                <Input
                  label='Name'
                  name='name'
                  required={
                    this.isVisible(localSignatureBlock.name_visibility) &&
                    !localSignatureBlock.signer_fills_fields
                  }
                  validationError='Name is required'
                  value={localSignatureBlock.name || ''}
                  onChange={this.textFieldChange}
                  submitted={this.props.submitted}
                  width='100%'
                />
                <div
                  className={styles.delete}
                  onClick={this.setVisibility.bind(null, 'name', false)}
                >
                  <Icon name='close' />
                </div>
              </div>}
            {!this.isVisible(localSignatureBlock.name_visibility) &&
              <p>
                <a onClick={this.setVisibility.bind(null, 'name', true)}>
                  + Add Name
                </a>
              </p>}
            {this.isVisible(localSignatureBlock.title_visibility) &&
              <div className={styles.optional}>
                <Input
                  label='Title'
                  name='title'
                  required={
                    this.isVisible(localSignatureBlock.title_visibility) &&
                    !localSignatureBlock.signer_fills_fields
                  }
                  validationError='Title is required'
                  value={localSignatureBlock.title || ''}
                  onChange={this.textFieldChange}
                  submitted={this.props.submitted}
                  width='100%'
                />
                <div
                  className={styles.delete}
                  onClick={this.setVisibility.bind(null, 'title', false)}
                >
                  <Icon name='close' />
                </div>
              </div>}
            {!this.isVisible(localSignatureBlock.title_visibility) &&
              this.isVisible(localSignatureBlock.company_name_visibility) &&
              <p>
                <a onClick={this.setVisibility.bind(null, 'title', true)}>
                  + Add Title
                </a>
              </p>}
            {this.isVisible(localSignatureBlock.company_name_visibility) &&
              <div className={styles.optional}>
                <Input
                  label='Company Name'
                  name='company_name'
                  required={
                    this.isVisible(
                      localSignatureBlock.company_name_visibility
                    ) && !localSignatureBlock.signer_fills_fields
                  }
                  validationError='Company name is required'
                  value={localSignatureBlock.company_name || ''}
                  onChange={this.textFieldChange}
                  submitted={this.props.submitted}
                  width='100%'
                />
                <div
                  className={styles.delete}
                  onClick={this.setVisibility.bind(null, 'company_name', false)}
                >
                  <Icon name='close' />
                </div>
              </div>}
            {!this.isVisible(localSignatureBlock.company_name_visibility) &&
              this.isVisible(localSignatureBlock.title_visibility) &&
              <p>
                <a
                  onClick={this.setVisibility.bind(null, 'company_name', true)}
                >
                  + Add Company Name
                </a>
              </p>}
            {!this.isVisible(localSignatureBlock.company_name_visibility) &&
              !this.isVisible(localSignatureBlock.title_visibility) &&
              <p>
                <a
                  onClick={() => {
                    this.setVisibility('company_name', true);
                    this.setVisibility('title', true);
                  }}
                >
                  + Add Title and Company Name
                </a>
              </p>}
            {this.isVisible(localSignatureBlock.email_visibility) &&
              <div className={styles.optional}>
                <Input
                  label='Email Address'
                  name='email'
                  required={
                    this.isVisible(localSignatureBlock.email_visibility) &&
                    !localSignatureBlock.signer_fills_fields
                  }
                  validations='isEmail'
                  validationError='Must be valid email address'
                  value={localSignatureBlock.email || ''}
                  onChange={this.textFieldChange}
                  submitted={this.props.submitted}
                  width='100%'
                />
                <div
                  className={styles.delete}
                  onClick={this.setVisibility.bind(null, 'email', false)}
                >
                  <Icon name='close' />
                </div>
              </div>}
            {!this.isVisible(localSignatureBlock.email_visibility) &&
              <p>
                <a onClick={this.setVisibility.bind(null, 'email', true)}>
                  + Add Email Address
                </a>
              </p>}
            {this.isVisible(localSignatureBlock.phone_visibility) &&
              <div className={styles.optional}>
                <Input
                  label='Phone Number'
                  name='phone'
                  required={
                    this.isVisible(localSignatureBlock.phone_visibility) &&
                    !localSignatureBlock.signer_fills_fields
                  }
                  validationError='Phone number is required'
                  value={localSignatureBlock.phone || ''}
                  onChange={this.textFieldChange}
                  submitted={this.props.submitted}
                  width='100%'
                />
                <div
                  className={styles.delete}
                  onClick={this.setVisibility.bind(null, 'phone', false)}
                >
                  <Icon name='close' />
                </div>
              </div>}
            {!this.isVisible(localSignatureBlock.phone_visibility) &&
              <p>
                <a onClick={this.setVisibility.bind(null, 'phone', true)}>
                  + Add Phone Number
                </a>
              </p>}
            {this.isVisible(localSignatureBlock.address_visibility) &&
              <div className={styles.optional}>
                <Input
                  label='Address'
                  name='address'
                  autoHeight
                  required={
                    this.isVisible(localSignatureBlock.address_visibility) &&
                    !localSignatureBlock.signer_fills_fields
                  }
                  validationError='Address is required'
                  value={localSignatureBlock.address || ''}
                  onChange={this.textFieldChange}
                  submitted={this.props.submitted}
                  width='100%'
                />
                <div
                  className={styles.delete}
                  onClick={this.setVisibility.bind(null, 'address', false)}
                >
                  <Icon name='close' />
                </div>
              </div>}
            {!this.isVisible(localSignatureBlock.address_visibility) &&
              <p>
                <a onClick={this.setVisibility.bind(null, 'address', true)}>
                  + Add Address
                </a>
              </p>}
            <br />
            <Checkbox
              label='Allow signing party to update their contact information'
              onChange={this.checkboxChange}
              name='signer_fills_fields'
              checked={localSignatureBlock.signer_fills_fields}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/SignatureBlocks/SignatureBlockFields.js